export default __webpack_public_path__ + "static/media/pers10.b3ce7dac.jpeg";